const resources = {
    pageTitle: 'Autoriser l’accès à votre compte Beauty Insider',
    whatCanDo: 'What ChatGPT can help you do',
    permission1: 'Recommander des produits que vous adorerez',
    permission2: 'Trouver et magasiner vos favoris plus rapidement',
    permission3: 'Découvrir les marques et les rituels qui vous conviennent',
    permission4: 'Access and update your Sephora shopping cart',
    allowAccessButton: 'Autoriser l’accès',
    cancelButton: 'Annuler',
    manageAccessText: 'Vérifiez ou supprimez l’accès en tout temps dans vos paramètres ChatGPT en vous déconnectant de l’appli Sephora.',
    privacyPrefix: 'Pour plus de détails sur l’utilisation de vos données par ChatGPT, consultez la',
    chatGPTPrivacyPolicy: 'politique de confidentialité de ChatGPT',
    privacyMiddle: '. Pour savoir comment Sephora protège vos renseignements, consultez la',
    sephoraPrivacyPolicy: 'politique de confidentialité de Sephora,',
    privacyEnd: '.',
    sessionIdNotFound: 'Session ID not found. Please restart the authorization flow.',
    authorizationFailed: 'Authorization failed. Please try again.',
    pageTitleGuest: 'Use ChatGPT with Sephora',
    permissionGuest1: 'Explore products and brands',
    permissionGuest2: 'Compare options and get recommendations',
    permissionGuest3: 'Discover routines, tips, and inspiration',
    personalizedHeader: 'Want a more personalized experience?',
    personalizedText: 'Connect your Beauty Insider account to tailor results to what you like and buy.',
    continueButton: 'Continue as a Guest',
    backButtonAriaLabel: 'Back'
};

export default function getResource(label) {
    return resources[label];
}
